import { MarketSortByType } from "./commonTypes";

interface IMarketSortOption {
  label: string;
  value: MarketSortByType;
}

export const marketSortOptions: IMarketSortOption[] = [
  {
    label: "Highest price",
    value: "highestPrice",
  },
  {
    label: "Lowest price",
    value: "lowestPrice",
  },
  {
    label: "Ending soon",
    value: "endingSoon",
  },
  {
    label: "Oldest",
    value: "oldest",
  },
];
